import { useNavigate } from 'react-router-dom'

import { Stack, Typography, IconButton } from '@mui/material'
import { KeyboardArrowLeft } from '@mui/icons-material'

interface PageHeaderProps {
  title?: string
  subtitle?: string
  backRoute?: string
  endComponent?: React.ReactNode
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, backRoute, endComponent }) => {
  const navigate = useNavigate()

  const handleOnClickGoBack = () => {
    if (backRoute) navigate(backRoute)
  }

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" position="relative" minHeight="2rem">
      {backRoute && (
        <IconButton onClick={handleOnClickGoBack} sx={{ position: 'absolute', left: 0 }}>
          <KeyboardArrowLeft />
        </IconButton>
      )}
      {title && (
        <Stack direction="column" spacing={0.25} alignItems="center" paddingX="2.5rem" minWidth={0}>
          <Typography variant="h6" fontWeight="bold" lineHeight={1.2} textAlign="center">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" lineHeight={1.2} textAlign="center">
              {subtitle}
            </Typography>
          )}
        </Stack>
      )}
      {endComponent}
    </Stack>
  )
}

export default PageHeader
